import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import Select, { CreatableSelect } from '@atlaskit/select';
import React from 'react';
import { BaseUserPickerWithoutAnalytics } from './BaseUserPicker';
import { getStyles } from './styles';
import { getComponents } from './components';
import { getCreatableProps } from './creatable';
import { getCreatableSuggestedEmailProps } from './creatableEmailSuggestion';
import MessagesIntlProvider from './MessagesIntlProvider';
import { ExusUserSourceProvider } from './../clients/UserSourceProvider';
export var UserPickerWithoutAnalytics = /*#__PURE__*/function (_React$Component) {
  _inherits(UserPickerWithoutAnalytics, _React$Component);

  var _super = _createSuper(UserPickerWithoutAnalytics);

  function UserPickerWithoutAnalytics() {
    _classCallCheck(this, UserPickerWithoutAnalytics);

    return _super.apply(this, arguments);
  }

  _createClass(UserPickerWithoutAnalytics, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          emailLabel = _this$props.emailLabel,
          allowEmail = _this$props.allowEmail,
          suggestEmailsForDomain = _this$props.suggestEmailsForDomain,
          isMulti = _this$props.isMulti,
          isValidEmail = _this$props.isValidEmail,
          anchor = _this$props.anchor,
          menuPortalTarget = _this$props.menuPortalTarget,
          menuPosition = _this$props.menuPosition,
          menuShouldBlockScroll = _this$props.menuShouldBlockScroll,
          captureMenuScroll = _this$props.captureMenuScroll,
          closeMenuOnScroll = _this$props.closeMenuOnScroll,
          loadUserSource = _this$props.loadUserSource;
      var width = this.props.width;
      var SelectComponent = allowEmail ? CreatableSelect : Select;
      var creatableProps = suggestEmailsForDomain ? getCreatableSuggestedEmailProps(suggestEmailsForDomain, isValidEmail) : getCreatableProps(isValidEmail);
      var defaultPickerProps = {
        closeMenuOnScroll: closeMenuOnScroll,
        menuPortalTarget: menuPortalTarget,
        menuPosition: menuPosition,
        menuShouldBlockScroll: menuShouldBlockScroll,
        captureMenuScroll: captureMenuScroll
      };
      var pickerProps = allowEmail ? _objectSpread(_objectSpread(_objectSpread({}, defaultPickerProps), creatableProps), {}, {
        emailLabel: emailLabel
      }) : _objectSpread({}, defaultPickerProps);
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(ExusUserSourceProvider, {
        fetchUserSource: loadUserSource
      }, /*#__PURE__*/React.createElement(BaseUserPickerWithoutAnalytics, _extends({}, this.props, {
        width: width,
        SelectComponent: SelectComponent,
        styles: getStyles(width, isMulti, this.props.styles),
        components: getComponents(isMulti, anchor),
        pickerProps: pickerProps
      }))));
    }
  }]);

  return UserPickerWithoutAnalytics;
}(React.Component);

_defineProperty(UserPickerWithoutAnalytics, "defaultProps", {
  width: 350,
  isMulti: false
});

export var UserPicker = withAnalyticsEvents()(UserPickerWithoutAnalytics);